/** The body copy inside an Info / T&C card — About, T&C and anything else operator-authored
 *  read as one text style, so the cards differ only in their titles. */
export const CARD_BODY_TEXT =
  "text-left text-[12px] leading-[18px] text-foreground-secondary lg:text-[14px] lg:leading-[22px]";
